"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
function isSFC(type) {
    return !type.prototype.render;
}
function convertToStatefulComponentClass(componentType) {
    var _a;
    if (isSFC(componentType)) {
        var statelessComponent_1 = componentType;
        return _a = /** @class */ (function (_super) {
                tslib_1.__extends(StatefulSFCWrapper, _super);
                function StatefulSFCWrapper() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                StatefulSFCWrapper.prototype.render = function () {
                    return statelessComponent_1(this.props);
                };
                return StatefulSFCWrapper;
            }(React.Component)),
            _a.displayName = getComponentName(statelessComponent_1),
            _a;
    }
    else {
        return componentType;
    }
}
exports.convertToStatefulComponentClass = convertToStatefulComponentClass;
function mergeEventHandlers(h1, h2) {
    return (h1 && h2 && function (e) { h1(e); h2(e); })
        || h1 || h2;
}
exports.mergeEventHandlers = mergeEventHandlers;
function isCallbackRef(ref) {
    return typeof ref === 'function';
}
exports.mergeRefs = function () {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (value) {
        refs.forEach(function (resolvableRef) { return assignRef(resolvableRef, value); });
    };
};
function assignRef(ref, value) {
    if (isCallbackRef(ref)) {
        ref(value);
    }
    else if (!!ref) {
        ref.current = value;
    }
}
exports.assignRef = assignRef;
// tslint:disable-next-line:no-any
function getComponentName(componentType) {
    return componentType.displayName || componentType.name || 'AnonymousComponent';
}
exports.getComponentName = getComponentName;
/** Adding this prop tells VizClient's event-utils to completely ignore the element */
exports.EventUtilsOptOutAttr = 'data-eventutils-optout';
exports.EventUtilsOptOut = Object.freeze((_a = {},
    _a[exports.EventUtilsOptOutAttr] = true,
    _a));
//# sourceMappingURL=ReactHelpers.js.map